export default __webpack_public_path__ + "static/media/1910.0671b30a.png";